import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { CourseOffering } from './course-offering.model';

export class CourseOfferingStateModel extends EntityStateModel<CourseOffering> {}
